<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header-profile">
    <h2>Change Password</h2>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="password-container">
      <section class="section-container nrg-border-radius">
        <div class="section-header">
          <mat-icon class="header-icon">password</mat-icon>
          <span>Password Information</span>
        </div>
        <div class="section-content">
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Current Password</mat-label>
              <input
                matInput
                formControlName="currentPassword"
                [type]="hideCurrentPassword ? 'password' : 'text'"
                required>
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="hideCurrentPassword = !hideCurrentPassword"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideCurrentPassword">
                <mat-icon>{{hideCurrentPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-error *ngIf="form.get('currentPassword')?.hasError('required')">
                Current password is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>New Password</mat-label>
              <input
                matInput
                formControlName="newPassword"
                [type]="hideNewPassword ? 'password' : 'text'"
                required>
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="hideNewPassword = !hideNewPassword"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideNewPassword">
                <mat-icon>{{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-error *ngIf="form.get('newPassword')?.hasError('required')">
                New password is required
              </mat-error>
              <mat-error *ngIf="form.get('newPassword')?.hasError('minlength')">
                Password must be at least 8 characters
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Confirm New Password</mat-label>
              <input
                matInput
                formControlName="confirmPassword"
                [type]="hideConfirmPassword ? 'password' : 'text'"
                required>
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="hideConfirmPassword = !hideConfirmPassword"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideConfirmPassword">
                <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-error *ngIf="form.get('confirmPassword')?.hasError('required')">
                Please confirm your password
              </mat-error>
              <mat-error *ngIf="form.hasError('passwordMismatch') && form.get('confirmPassword')?.touched">
                Passwords do not match
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </section>

      <section class="section-container nrg-border-radius password-requirements">
        <div class="section-header">
          <mat-icon class="header-icon">info</mat-icon>
          <span>Password Requirements</span>
        </div>
        <div class="section-content">
          <div class="requirement-item" [class.met]="isRequirementMet('minLength')" [class.error]="hasError('minLength') && newPasswordControl?.touched">
            <mat-icon class="requirement-icon">
              {{ isRequirementMet('minLength') ? 'check_circle' : (hasError('minLength') && newPasswordControl?.touched ? 'cancel' : 'radio_button_unchecked') }}
            </mat-icon>
            <span>At least 8 characters long</span>
          </div>
          <div class="requirement-item" [class.met]="isRequirementMet('uppercase') && isRequirementMet('lowercase')" [class.error]="(hasError('uppercase') || hasError('lowercase')) && newPasswordControl?.touched">
            <mat-icon class="requirement-icon">
              {{ isRequirementMet('uppercase') && isRequirementMet('lowercase') ? 'check_circle' : ((hasError('uppercase') || hasError('lowercase')) && newPasswordControl?.touched ? 'cancel' : 'radio_button_unchecked') }}
            </mat-icon>
            <span>Contains uppercase and lowercase letters</span>
          </div>
          <div class="requirement-item" [class.met]="isRequirementMet('number')" [class.error]="hasError('number') && newPasswordControl?.touched">
            <mat-icon class="requirement-icon">
              {{ isRequirementMet('number') ? 'check_circle' : (hasError('number') && newPasswordControl?.touched ? 'cancel' : 'radio_button_unchecked') }}
            </mat-icon>
            <span>Contains at least one number</span>
          </div>
          <div class="requirement-item" [class.met]="isRequirementMet('specialChar')" [class.error]="hasError('specialChar') && newPasswordControl?.touched">
            <mat-icon class="requirement-icon">
              {{ isRequirementMet('specialChar') ? 'check_circle' : (hasError('specialChar') && newPasswordControl?.touched ? 'cancel' : 'radio_button_unchecked') }}
            </mat-icon>
            <span>Contains at least one special character</span>
          </div>
        </div>
      </section>
    </div>

    <div class="form-actions">
      <button
        mat-flat-button
        class="nrg-secondary-flat-button"
        type="submit"
        [disabled]="!form.valid">
        <mat-icon>lock_reset</mat-icon>
        Change Password
      </button>
      <button
        mat-flat-button
        type="button"
        class="nrg-error-flat-button"
        (click)="onCancel()">
        <mat-icon>clear</mat-icon>
        Cancel
      </button>
    </div>
  </form>
</div>
